import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Healthcareservice } from 'app/core/interfaces/healthcareservice';
import { friendlyProcedureName } from '../../models/schedule-search.models';

@Component({
  selector: 'schedule-service-option',
  templateUrl: './schedule-service-option.component.html',
  styleUrls: ['./schedule-service-option.component.scss'],
})
export class ScheduleServiceOptionComponent {
  @Input() service?: Healthcareservice;
  @Input() locationLabel = '';
  @Input() privatePriceLabel = '';
  @Input() coverageLabel = '';
  @Input() providers: string[] = [];
  @Output() schedule = new EventEmitter<void>();

  get displayName(): string {
    return friendlyProcedureName(this.service?.name);
  }

  get categories(): string[] {
    const values = [this.service?.type, this.service?.specialty]
      .map((value) => (value ?? '').trim())
      .filter(Boolean);

    return Array.from(
      new Map(values.map((value) => [value.toLocaleLowerCase('pt-BR'), value])).values()
    );
  }

  get scheduleLabel(): string {
    return this.service?.serviceDealer === 'Organização' ? 'Ver horários' : 'Ver profissionais e horários';
  }
}
